/*jshint esversion: 8 */
//{/* use this to comment inside jsx*/}
import './styles/home.css';
import './styles/lending.css';
import Image from 'react-bootstrap/Image';
import React, {useState, useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import ab from './pix/mail.png';
import mp from './pix/arrow-right-1.png';
import l4 from './pix/l4.svg';
import st from './pix/structure.svg';
import dollar from './pix/dollar.svg';
import geo from './pix/geo.svg';
import trans from './pix/trans.png';
import prof from './pix/prof.svg';
import lend from './pix/lend.jpg';
import reach from './util/home/Global-Reach-scaled.jpg'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown';
import Accordion from 'react-bootstrap/Accordion';
import Nav from 'react-bootstrap/Nav';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Navbar from 'react-bootstrap/Navbar';
import Form from 'react-bootstrap/Form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons';

{/**logo should be png file, have a transparent background */}

function Lending () {
    const navigate = useNavigate();
    const [expanded, setExpanded] = useState(false);
    const [aboutUsHover, setAboutUsHover] = useState(false);
    const [strategiesHover, setStrategiesHover] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);

    useEffect(() => {
        document.body.classList.toggle("menu-open", menuOpen);
        // Cleanup: make sure class is removed if the component unmounts
        // while the menu is open (e.g. route change).
        return () => {
            if (menuOpen) document.body.classList.remove("menu-open");
        };
    }, [menuOpen]);

    // Simple toggle for the hamburger button — no more manual DOM calls here.
    const toggleMenu = () => {
        setMenuOpen(prev => !prev);
    };

    // Dedicated close function used by the X button, overlay, and nav items.
    const closeMenu = () => {
        setMenuOpen(false);
    };
    // Add these states for mobile dropdowns (separate from desktop)
    const [mobileAboutOpen, setMobileAboutOpen] = useState(false);
    const [mobileStrategiesOpen, setMobileStrategiesOpen] = useState(false);
    // New State for Scroll Effect
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            // If user scrolls more than 150px, trigger the fixed state
            if (window.scrollY > 150) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
     <div class=''>

    <Navbar id='nav-ham' expanded={expanded} onToggle={() => setExpanded(!expanded)} collapseOnSelect expand="lg" fixed="top" className={`custom-navbar ${scrolled ? 'navbar-fixed-reveal' : ''}`} variant="light">
  <Container className="d-flex w-100 align-items-center justify-content-between" id='nav-con-f'>
  <Navbar.Brand href="/"><Image
                src={l4}
                id='nav-img-og'
                alt="shereen Logo"
            /></Navbar.Brand>

{/* Custom Hamburger Button for mobile */}
  <button
  id='burg'
  className={`hamburger-button ${menuOpen ? "active" : ""}`}
  onClick={toggleMenu}
  aria-label="Menu"
>
  <span className="hamburger-line"></span>
  <span className="hamburger-line"></span>
  <span className="hamburger-line"></span>
</button>

  <Navbar.Collapse id="responsive-navbar-nav" style = {{}}>
    <Nav className="ms-auto align-items-center"  style = {{marginRight: '-10%'}}  >
    <NavDropdown
                    title={
                        <span  onMouseEnter={() => setAboutUsHover(true)}
                        onMouseLeave={() => setAboutUsHover(false)} className="custom-span">
                            About Us <FontAwesomeIcon icon={faChevronDown}  className="dropdown-arrow ms-2" style = {{fontSize: '18px'}}/>
                        </span>
                    }
                    id="aboutus-dropdown"
                    className="nav-dropdown-custom"
                    show={aboutUsHover}
                >
                    <NavDropdown.Item onClick={() => navigate('/corporate-governance')}>
                        Corporate Governance
                    </NavDropdown.Item>
                    <NavDropdown.Item onClick={() => navigate('/chairmans-message')}>
                        Chairman's Message
                    </NavDropdown.Item>
                </NavDropdown>

      {/**SECOND NAV HOV */}
    <NavDropdown
    title={
        <span  onMouseEnter={() => setStrategiesHover(true)}
                onMouseLeave={() => setStrategiesHover(false)} className="custom-span">
            Our Strategies <FontAwesomeIcon icon={faChevronDown} style = {{fontSize: '18px'}} className="dropdown-arrow ms-2" />
        </span>
    }

    id="strategies-dropdown"
    className="nav-dropdown-custom"
    show={strategiesHover}
>
    <NavDropdown.Item onClick={() => navigate('/opportunities')}>
        Opportunistic Investing
    </NavDropdown.Item>
    <NavDropdown.Item onClick={() => navigate('/lending')}>
        Direct Lending
    </NavDropdown.Item>
    <NavDropdown.Item onClick={() => navigate('/liquidity-solutions')}>
        Fund Liquidity Solutions
    </NavDropdown.Item>
    <NavDropdown.Item onClick={() => navigate('/corporate-finance')}>
        Corporate Financing
    </NavDropdown.Item>
    <NavDropdown.Item onClick={() => navigate('/estate')}>
        Real Estate
    </NavDropdown.Item>
</NavDropdown>
      <Nav.Link id="nav-lks" onClick={() => navigate('/team')}>Our Team</Nav.Link>
      <Nav.Link id="nav-lks"  onClick={() => navigate('/careers')}>Careers</Nav.Link>
      <Nav.Link id="nav-lks"  onClick={() => navigate('/contact-us')}>Contact Us</Nav.Link>

    </Nav>

  </Navbar.Collapse>
  </Container>
</Navbar>

{/* ====================== CUSTOM MOBILE SLIDE MENU ====================== */}
{/* ====================== FULL SCREEN MOBILE SLIDE MENU ====================== */}
<div className={`mobile-menu-fullscreen ${menuOpen ? 'active' : ''}`}>
  <div className="mobile-menu-overlay" onClick={() => setMenuOpen(false)}></div>
  <div className="mobile-menu-container">
    <button className="mobile-menu-close" onClick={() => setMenuOpen(false)}>×</button>

    <div className="mobile-menu-content">
      <Nav className="flex-column mobile-nav-stack">

        {/* About Us with Dropdown */}
<div className="mobile-dropdown-wrapper">
<div className="mobile-menu-item" style={{ justifyContent: 'space-between', alignItems: 'center' }}>
  <span
    className="mobile-menu-text"
    onClick={() => { navigate('/abt'); setMenuOpen(false); }}
    style={{ flex: 1, cursor: 'pointer' }}
  >
    About Us
  </span>
  <span
    className={`dropdown-arrow ${mobileAboutOpen ? 'open' : ''}`}
    onClick={() => setMobileAboutOpen(!mobileAboutOpen)}
    style={{ cursor: 'pointer', marginLeft:'20px'}}
  >
    ▼
  </span>
</div>
{mobileAboutOpen && (
  <div className="mobile-sub-menu">
    <div className="sub-item" onClick={() => { navigate('/corporate-governance'); setMenuOpen(false); }}>
      Corporate Governance
    </div>
    <div className="sub-item" onClick={() => { navigate('/chairmans-message'); setMenuOpen(false); }}>
      Chairman's Message
    </div>
  </div>
)}
</div>

        {/* Our Strategies with Dropdown */}
        <div className="mobile-dropdown-wrapper">
          <div
          className="mobile-menu-item"
          onClick={() => setMobileStrategiesOpen(!mobileStrategiesOpen)}
          style={{ justifyContent: 'space-between', alignItems: 'center' }}
        >
          <span style={{ flex: 1, cursor: 'pointer' }}>
            Our Strategies
          </span>
          <span className={`dropdown-arrow ${mobileStrategiesOpen ? 'open' : ''}`}>▼</span>
        </div>
          {mobileStrategiesOpen && (
            <div className="mobile-sub-menu">
              <div className="sub-item" onClick={() => { navigate('/opportunities'); setMenuOpen(false); }}>
                Opportunistic Investing
              </div>
              <div className="sub-item" onClick={() => { navigate('/lending'); setMenuOpen(false); }}>
                Direct Lending
              </div>
              <div className="sub-item" onClick={() => { navigate('/liquidity-solutions'); setMenuOpen(false); }}>
                Fund Liquidity Solutions
              </div>
              <div className="sub-item" onClick={() => { navigate('/corporate-finance'); setMenuOpen(false); }}>
                Corporate Financing
              </div>
              <div className="sub-item" onClick={() => { navigate('/estate'); setMenuOpen(false); }}>
                Real Estate
              </div>
            </div>
          )}
        </div>

        {/* Our Team */}
        <div className="mobile-menu-item" onClick={() => { navigate('/team'); setMenuOpen(false); }}>
          Our Team
        </div>

        {/* Careers */}
        <div className="mobile-menu-item" onClick={() => { navigate('/careers'); setMenuOpen(false); }}>
          Careers
        </div>

        {/* Contact Us */}
        <div className="mobile-menu-item no-border" onClick={() => { navigate('/contact-us'); setMenuOpen(false); }}>
          Contact Us
        </div>

      </Nav>
    </div>
  </div>
</div>

      {/**hero section start*/}
      <Container fluid className="px-0" style={{
        marginTop: '6%',
        paddingTop: '80px',
        paddingBottom: '80px',
        backgroundColor: '#CD1C18',
        color: '#ffffff',
        overflow: 'visible', // Allows the image to overlap the bottom edge
        position: 'relative',
        zIndex: 1
    }}>
            <Row  id='top-row' >
            <Col md = {6} xs={12} id="career-col-ldo">
            <Row id='career-txt'><span id='career-bar-f'></span> Direct Lending</Row>
            <Row id="ct">Financing to Lower- and Middle-market Companies</Row>
          </Col>
          <Col id="border-ln" md = {4} style={{ position: 'relative', zIndex: 10, }}>
          <Image

              src={lend}
              style={{
                  width: '100%',
                  height: 'auto',
                  objectFit: 'cover',
                  position: 'relative',
                  zIndex: 1, // Image sits below the border lines
                  marginBottom: '-200px', // Pushes image into the next container
                  boxShadow: '0 20px 40px rgba(0,0,0,0.2)',
                  display: 'block'
              }}
              alt="Shereen Logo"
          />
      </Col>
            </Row>
       </Container>
       {/**hero section end*/}

       <Container >
        <Row   id='bal-col-rw-ld' >
            <Col id = 'balance-col-ln' md = {6} xs={12}>Shereen’s direct lending strategy provides $20mm to $200mm+ tailored financing solutions to sponsor and non-sponsor backed lower and middle-market companies across Middle East.</Col>
        </Row>
       </Container>

       {/**secured */}
       <Container fluid style = {{backgroundColor: '#f8f8f8'}}>
                <Row  id='tailored-row-ln'>
                    <Row id='flexible-row-lnd'>Thinking Outside the Box to Secured Lending</Row>
                    <Row>
                      <Col   md = {5} xs={12} id='fortress-col-ln'>
                        <Row id='fortress-col-txt' >Shereen Investment’s direct lending philosophy emphasizes creative “out of the box” thinking when originating loans to middle market companies. Our seasoned team of investment professionals seek to find value others miss due to our specialized industry approach.</Row>
                        <Row  id='fortress-col-txt'>Areas of focus include businesses with one or multiple of the following attributes: recurring revenues, defensive multi-site models and hard assets. Industry verticals include, but are not limited to, business services, healthcare, industrial services, payment processing, media, software & technology, security and specialty finance.</Row>
                        <Row id='fortress-col-txt'>Shereen Investment’s expansive platform enables our deal teams to be a valued-added resource for companies by utilizing our experienced advisor network of current and former executives for industry intelligence.</Row>
                        <Row id='fortress-col-txt'>Shereen Investment Company LLC have arranged and structured more than $5.7 Billion capital investments on an exclusive basis for some of esteemed clients worldwide. This execution comes from in-depth upfront analysis, underwriting and structuring coupled with deep relationships and real time feedback from the debt financing team. Unfortunately, very little debt financing is available to early-stage entrepreneurs, because lenders expect loans to be paid back in a pre-defined and timely manner with interest. We can take the stress off and let you focus on the important things.</Row>
                      </Col>
                      <Col md = {5} xs={12} id='fortress-col-ld'>
                        <Row id='fortress-col-txt'>Shereen Investment Company LLC has always stayed true to its original vision: providing our esteemed clients the same Tailored Solutions and Funding Packages in International Project Financing by way of Debt Financing - for existing Companies as well as Start-Ups. Debt funding is advantageous for growing companies. Not only is it cheaper than raising equity, it also helps you preserve your ownership stake. And when you're just starting your business, it makes sense to preserve your equity for as long as possible.</Row>
                        <Row id='fortress-col-txt'>We can arrange and implement financing for all kinds of companies and find the most suitable financing options to the momentum business requirements. Companies can also find a solution with Shereen Investment Company LLC when the common credit facility is not the most suitable one. Our loans and lines of credit are flexible, multiple and innovative.</Row>
                        <Row id='fortress-col-txt'>Shereen Investment Company LLC has developed close working relationships with groups of Professionals: Specialists in Finance, Commercial Risks Insurance and Re-Insurance, International Accounting Firms and Law Firms, and the largest Valuation Firm in the world. We specialise in creating 'broadly-based' diversified investment portfolios based on our tried and tested investment process.</Row>
                      </Col>
                    </Row>
                </Row>
       </Container>

    {/**parameters */}
      <Container fluid id='invest-container-ln'  >
            <Row  id='invest-params-txt-ln' xs={12}  >Investment Parameters</Row>
            <Row >
                <Col md = {3} xs={12} id='invest-cols-ld' >
                     <Col  xs={12} id='' style = {{}}>
                <Card className="border-0" style={{   backgroundColor: '#dee3ed', marginBottom: '10%', paddingBottom: '8%'}} >
                <Card.Body  >

                <Card.Img variant="top" src = {dollar} style={{ height: '64px', width: 'auto', marginLeft: '5%'}}/>
                <Card.Title id='card-ld-ttl' >Investment Size</Card.Title>
                <Card.Text id='card-ld-tx' >
                             $20m - $2bn
                    </Card.Text>

                </Card.Body>
                </Card>
                    </Col>

                     <Col xs={12}   id=''>
                <Card className="border-0" style={{   backgroundColor: '#dee3ed', marginBottom: '10%', paddingBottom: '8%'}} >
                <Card.Body  >

                <Card.Img variant="top" src = {geo} style={{ height: '64px', width: 'auto', marginLeft: '6%'}}/>
                <Card.Title id='card-ld-ttl'>Geography</Card.Title>
                <Card.Text id='card-ld-tx'>
                             Middle East
                    </Card.Text>

                </Card.Body>
                </Card>
                    </Col>

                </Col>

                <Col md = {3} xs={12} id='invest-cols-ld'>
                <Card className="border-0" style={{   backgroundColor: '#dee3ed', paddingBottom: '64%'}} >
                <Card.Body  >

                <Card.Img variant="top" src = {st} style={{ height: 'auto', width: 'auto', marginLeft: '7%'}}/>
                <Card.Title id='card-ld-ttl'>Structures</Card.Title>
                <Card.Text id='card-ld-tx'>
                <ul>
                            <li>1st Lien Debt</li>
                            <li>2nd Lien Debt</li>
                            <li>Unitranche</li>

                    </ul>
                    </Card.Text>

                </Card.Body>
                </Card>
            </Col>

                <Col md = {3} xs={12} id='invest-cols-ld'>
                <Card className="border-0" style={{   backgroundColor: '#dee3ed', paddingBottom: '13%'}} >
                <Card.Body  >

                <Card.Img variant="top" src = {trans} style={{ height: '64px', width: 'auto', marginLeft: '7%'}}/>
                <Card.Title id='card-ld-ttl'>Transactions</Card.Title>
                <Card.Text  id='card-ld-tx'>
                <ul>
                            <li>Acquisition Financing</li>
                            <li>Corporate Carve-outs</li>
                            <li>Growth Capital</li>
                            <li>Leveraged Buyouts</li>
                            <li>Refinancing</li>
                            <li>Recapitalization</li>
                            <li>Secondary Purchases</li>
                    </ul>
                    </Card.Text>

                </Card.Body>
                </Card>
            </Col>

                <Col md = {3} xs={12} id='invest-cols-ld'>
                <Card className="border-0" style={{   backgroundColor: '#dee3ed', paddingBottom: '48%'}} >
                <Card.Body  >

                <Card.Img variant="top" src = {prof} style={{ height: '64px', width: '64px', marginLeft: '1%'}}/>
                <Card.Title id='card-ld-ttl'>Ownership Profile</Card.Title>
                <Card.Text  id='card-ld-tx'>
                <ul>
                            <li>Sponsored</li>
                            <li>Hybrid</li>
                            <li>Non-sponsored</li>
                            <li>Public</li>
                    </ul>
                    </Card.Text>

                </Card.Body>
                </Card>
            </Col>

            </Row>
      </Container>

      {/**investment type*/}

      <Container fluid id='bridge-container'>
        <Row  id='bridge-industry-txt'>Types of Investments</Row>
        <Row    style={{fontFamily: 'Lato-light', fontWeight: '300', fontSize: '20px', lineHeight: '32px', marginTop: '4%', color: '#ffffff'}}>
            <Col    md = {4} xs={12}><ul>
                <li >Cash Flow Loans</li>
                <li>Corporate Carve-outs</li>
            </ul></Col>
            <Col    md = {4} xs={12}><ul>
            <li>Enterprise Value Financings</li>
            <li>Recurring Revenue Lending</li>
        </ul></Col>
            <Col md = {4} xs={12}><ul>
            <li>Bridge, Specialty or Asset-backed Loans</li>

        </ul></Col>
        </Row>
      </Container>
{/**seking capital sect */}
      <Container  fluid className="px-0">
  <Row   style = {{marginTop: '1%'}}>
        {/* Card 1: Seeking Capital */}
        <Col lg={6} xs={12}>
            <Card
                className="cta-card"
                style={{
                    backgroundColor: '#24325B',
                    borderRadius: '0',
                    border: 'none',
                    height: '100%'
                }}
            >
                <Card.Body className="text-center py-5 px-4 px-md-5">
                    <Image src={ab} style={{ height: '32px' }} alt="mail" />

                    <h2 style={{
                        fontFamily: 'rufinaalt01',
                        fontWeight: '400',
                        fontSize: 'clamp(28px, 5.5vw, 48px)',
                        lineHeight: '1.15',
                        color: '#ffffff',
                        marginTop: '28px'
                    }}>
                        Interested in Seeking Capital
                    </h2>

                    <p style={{
                        fontFamily: 'Lato',
                        fontWeight: '400',
                        fontSize: 'clamp(18px, 4vw, 24px)',
                        lineHeight: '1.45',
                        color: '#ffffff',
                        maxWidth: '580px',
                        margin: '24px auto 0'
                    }}>
                        Contact us to learn how we apply creativity and flexibility to our capital solutions.
                    </p>

                    <div style={{ marginTop: '45px' }}>
                        <a
                            className="box"
                            href=""
                            onClick={() => navigate('/contact-us')}
                            style={{
                                border: '1px solid #f7f5f0',
                                padding: '18px 24px',
                                display: 'inline-block',
                                borderRadius: '8px',
                                cursor: 'pointer',
                                transition: 'all 0.4s ease'
                            }}
                        >
                            <Image src={mp} alt="arrow" style={{ width: '26px' }} />
                        </a>
                    </div>
                </Card.Body>
            </Card>
        </Col>

        {/* Card 2: Join Our Team */}
        <Col lg={6} xs={12}>
            <Card
                className="cta-card"
                style={{
                    backgroundColor: '#CD1C18',
                    borderRadius: '0',
                    border: 'none',
                    height: '100%'
                }}
            >
                <Card.Body className="text-center py-5 px-4 px-md-5">
                    <Image src={ab} style={{ height: '32px' }} alt="mail" />

                    <h2 style={{
                        fontFamily: 'rufinaalt01',
                        fontWeight: '400',
                        fontSize: 'clamp(28px, 5.5vw, 48px)',
                        lineHeight: '1.15',
                        color: '#ffffff',
                        marginTop: '28px'
                    }}>
                        Join Our Team
                    </h2>

                    <p style={{
                        fontFamily: 'Lato',
                        fontWeight: '400',
                        fontSize: 'clamp(18px, 4vw, 24px)',
                        lineHeight: '1.45',
                        color: '#ffffff',
                        maxWidth: '580px',
                        margin: '24px auto 0'
                    }}>
                        Strong partnerships with customers start with the right colleagues.
                    </p>

                    <div style={{ marginTop: '45px' }}>
                        <a
                            className="box"
                            href=""
                            onClick={() => navigate('/careers')}
                            style={{
                                border: '1px solid #f7f5f0',
                                padding: '18px 24px',
                                display: 'inline-block',
                                borderRadius: '8px',
                                cursor: 'pointer',
                                transition: 'all 0.4s ease'
                            }}
                        >
                            <Image src={mp} alt="arrow" style={{ width: '26px' }} />
                        </a>
                    </div>
                </Card.Body>
            </Card>
        </Col>
          </Row>
      </Container>

            {/**footer section */}
            <Container  fluid style ={{backgroundColor: '#efefef', fontFamily: 'Lato',  paddingBottom: '10px'}}> {/**marginRight: '2%' */}


            <Row id='ft-txt'> © Copyright 2026 Shereen Investment Company LLC</Row>
                                    <Row id= 'last-rw' className='d-md-none m-0 p-0'>
            <Col id='linkd' xs={12} onClick={() => navigate('/')}><FontAwesomeIcon icon={faLinkedin} className="me-2" /></Col>
                  </Row>




    </Container>

            {/*the below div is last div/ function component div*/}
          </div>
    )
}

export default Lending;
